<template>
  <div class="app-sidebar colored">
    <div class="sidebar-header">
      <router-link
        class="header-brand"
        href="#"
        :to="{name: 'home'}">
        <div class="logo-img">
          <img
            src="/static/images/logo_small.png"
            class="header-brand-img"
            alt="Api4Com - API de VOZ integrado com seu CRM">
        </div>
        <span class="text">
          <img
            src="/static/images/logo_only_name.png"
            class="header-brand-name-img"
            alt="Api4Com - API de VOZ integrado com seu CRM">
        </span>
      </router-link>
      <button
        id="sidebarClose"
        class="nav-close"><i class="ik ik-x" /></button>
    </div>
    <!-- Alca na borda do menu (padrao Asaas/Notion). Fica fora da lista de
         navegacao de proposito: no rodape ela vivia colada no "Sair", e um
         clique errado ali desloga o usuario. Aqui nao encosta em nada, e segue
         a divisa quando o menu recolhe. -->
    <button
      type="button"
      class="sidebar-handle nav-toggle"
      :title="collapseToggleLabel"
      :aria-label="collapseToggleLabel"
      :aria-expanded="isCollapsed ? 'false' : 'true'">
      <i
        data-toggle="expanded"
        class="ik ik-chevrons-left toggle-icon" />
    </button>
    <div class="sidebar-content">
      <div class="nav-container">
        <nav
          id="main-menu-navigation"
          class="navigation-main">
          <a
            v-if="showChargeChip"
            class="charge-alert-chip"
            :class="chargeChipState"
            href="#"
            :title="chargeChipText"
            @click.prevent="onChargeChipClick">
            <i class="ik ik-alert-circle" />
            <span>{{ chargeChipText }}</span>
          </a>
          <div v-if="isFounder" class="nav-item home">
            <router-link
              title="Início"
              href="#"
              :to="{name: 'home'}">
              <i class="ik ik-home" /><span>Início</span>
            </router-link>
          </div>
          <div class="nav-item dashboard">
            <router-link
              title="Dashboard"
              href="#"
              :to="{name: 'dashboard'}">
              <i class="ik ik-bar-chart-2" /><span>Dashboard</span>
            </router-link>
          </div>
          <div class="nav-item reportCalls">
            <router-link
              title="Relatórios"
              href="#"
              class="menu-item"
              :to="{name: 'reportCalls'}">
              <i class="ik ik-file-text" /><span>Relatórios</span>
            </router-link>
          </div>
          <div class="nav-item webphone">
            <router-link
              title="Webphone"
              :to="{ name: 'webphone' }">
              <i class="ik ik-phone-call" /><span>Webphone</span>
            </router-link>
          </div>
          <!-- Vizinho do Webphone porque e da mesma familia: ferramenta que o
               vendedor abre para trabalhar, nao configuracao da conta. Esteve na
               area utilitaria do rodape (entre o divisor e o Suporte) e voltou:
               la ele precisava de uma regra so dele para escapar do rebaixamento
               daquela area — quando um item precisa desfazer o estilo do lugar,
               o lugar esta errado. -->
          <div class="nav-item ia4com" v-if="isIA4comAllowed">
            <router-link
              title="IA4COM"
              :to="{ name: 'ia4com' }">
              <i class="icon-ia" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 2.5 11.75 7.75 17 9.5 11.75 11.25 10 16.5 8.25 11.25 3 9.5 8.25 7.75Z" />
                  <path d="M17.5 13 18.4 15.6 21 16.5 18.4 17.4 17.5 20 16.6 17.4 14 16.5 16.6 15.6Z" />
                </svg>
              </i><span class="menu-label">
                IA4COM
                <span class="badge new">Beta</span>
              </span>
            </router-link>
          </div>
          <!--TODO: Blacklist-->
          <div
            class="nav-item subscription pricing"
            v-if="isAdmin">
            <router-link
              :title="isUnlimitedPlan ? 'Conhecer Planos' : 'Planos e Assinatura'"
              href="#"
              :to="isUnlimitedPlan ? { name: 'pricing' } : { name: 'subscription' }">
              <i class="ik ik-layers" />
              <span class="menu-label">
                {{ isUnlimitedPlan ? 'Conhecer Planos' : 'Planos e Assinatura' }}
                <span class="badge black" v-if="hasCampaignOffer">Black</span>
                <span class="badge new" v-else-if="!isUnlimitedPlan">Novo</span>
              </span>
            </router-link>
          </div>
          <div
            class="nav-item usersList"
            v-if="isAdmin">
            <router-link
              title="Usuários"
              :to="{ name: 'usersList' }">
              <i class="ik ik-users" /><span>Usuários</span>
            </router-link>
          </div>
          <div class="nav-item integrationManager">
            <router-link
              title="Integrações"
              href="#"
              :to="{name: 'integrationManager'}">
              <i class="ik ik-share-2" /><span>Integrações</span>
            </router-link>
          </div>
          <div class="nav-item accessTokens">
            <router-link
              title="Tokens de acesso"
              href="#"
              :to="{name: 'accessTokens'}">
              <i class="ik ik-lock" /><span>Tokens de acesso</span>
            </router-link>
          </div>
          <div class="nav-item" v-if="isGoogleDataStudioAllowed">
            <a
              title="Google Data Studio"
              href="#"
              @click.prevent="openTutorialGoogleDataStudio">
              <i class="ik ik-database" /><span>Google Data Studio</span>
            </a>
          </div>
          <div class="nav-divider" />
          <div class="nav-utility">
            <div class="nav-item support">
              <a
                title="Suporte"
                href="https://wa.me/554833328503"
                target="_blank"
                rel="noopener noreferrer">
                <i class="icon-whatsapp" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 0 1 6.99 2.896 9.83 9.83 0 0 1 2.895 6.994c-.003 5.45-4.437 9.885-9.889 9.885m8.413-18.297A11.8 11.8 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.9 11.9 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 0 0-3.48-8.413" />
                  </svg>
                </i><span>Suporte</span>
              </a>
            </div>
            <div class="nav-item">
              <a
                title="Sair"
                href="#"
                @click="onLogoutClick">
                <i class="ik ik-power" /><span>Sair</span>
              </a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '../../services/loopback'
import { EventBus } from '../../services/event-bus'
import { isFeatureAllowed, IA4COM_FEATURE_FLAG } from '../../services/rollout'
import { loadAndMapOffers } from '../../services/pricing-offers'
import { isCampaignBannerActive } from '../Subscription/plan-showcase'

const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed'

export default {
  name: 'MenuSidebar',
  data: () => ({
    isUnlimitedPlan: false,
    hasCampaignOffer: false,
    hasPendingCharge: false,
    hasOverdueCharge: false,
    isGoogleDataStudioAllowed: false,
    isIA4comAllowed: false,
    isCollapsed: false
  }),
  mounted () {
    this.$nextTick(function () {
      function closeSubmenu (e) {
        e.removeClass('open')
      }
      function openSubmenu (e) {
        e.addClass('open')
      }
      const enableMenuCollapsed = (element, wrapper) => {
        wrapper.addClass('nav-collapsed nav-expanded')
        $('.nav-toggle').find('.toggle-icon').removeClass('ik-chevrons-left').addClass('ik-chevrons-right')
        element.attr('data-toggle', 'collapsed')
        this.isCollapsed = true
      }
      const disableMenuCollapsed = (element, wrapper) => {
        wrapper.removeClass('nav-collapsed menu-collapsed nav-expanded')
        $('.nav-toggle').find('.toggle-icon').removeClass('ik-chevrons-right').addClass('ik-chevrons-left')
        element.attr('data-toggle', 'expanded')
        this.isCollapsed = false
      }
      const sidebar = $('.app-sidebar')
      const menus = $('.sidebar-content')
      const wrapper = $('.wrapper')
      menus.on('click', '.navigation-main .nav-item a', function () {
        const e = $(this).parent('.nav-item')
        if (e.hasClass('has-sub') && e.hasClass('open')) closeSubmenu(e)
        else {
          if (e.hasClass('has-sub')) {
            openSubmenu(e)
            if (menus.data('collapsible')) return !1
            closeSubmenu(e.siblings('.open'))
            e.siblings('.open').find('.nav-item.open').removeClass('open')
          }
        }
      })
      $('.nav-toggle').on('click', (event) => {
        const toggleIcon = $(event.currentTarget).find('.toggle-icon')
        if (toggleIcon.attr('data-toggle') === 'expanded') {
          enableMenuCollapsed(toggleIcon, wrapper)
        } else {
          disableMenuCollapsed(toggleIcon, wrapper)
        }

        const isCollapsed = wrapper.hasClass('nav-collapsed')

        if (isCollapsed) {
          wrapper.addClass('nav-expanded')
          this.$root.$emit('sidebar-hover', true)
        } else {
          wrapper.removeClass('nav-expanded')
        }

        this.persistCollapsedState(isCollapsed)
        this.$root.$emit('sidebar-toggle', isCollapsed)
      })
      sidebar.on('mouseenter', () => {
        if (wrapper.hasClass('nav-collapsed')) {
          wrapper.removeClass('menu-collapsed')
          menus.find('.nav-item.active').parents('.nav-item').addClass('open')
          $('.navigation-main .nav-item.nav-collapsed-open').addClass('open').removeClass('nav-collapsed-open')
          this.handleSidebarHover(true)
        }
      }).on('mouseleave', () => {
        if (wrapper.hasClass('nav-collapsed')) {
          wrapper.addClass('menu-collapsed')
          $('.navigation-main .nav-item.open').addClass('nav-collapsed-open').removeClass('open')
          this.handleSidebarHover(false)
        }
      })
      if ($(window).width() < 992) {
        sidebar.addClass('hide-sidebar')
        wrapper.removeClass('nav-collapsed menu-collapsed')
      } else if (this.readCollapsedState()) {
        enableMenuCollapsed($('.nav-toggle').find('.toggle-icon'), wrapper)
        wrapper.removeClass('nav-expanded').addClass('menu-collapsed')
        this.$root.$emit('sidebar-toggle', true)
      }
      $(window).resize(function () {
        if ($(window).width() < 992) {
          sidebar.addClass('hide-sidebar')
          wrapper.removeClass('nav-collapsed menu-collapsed')
        } else {
          sidebar.removeClass('hide-sidebar')
          if ($('.toggle-icon').attr('data-toggle') === 'collapsed' && wrapper.not('.nav-collapsed menu-collapsed')) {
            wrapper.addClass('nav-collapsed menu-collapsed')
          }
        }
      })
      $(document).on('click', '.navigation li:not(.has-sub)', function () {
        if ($(window).width() < 992) sidebar.addClass('hide-sidebar')
      })
      $(document).on('click', '.logo-text', function () {
        if ($(window).width() < 992) sidebar.addClass('hide-sidebar')
      })
      // O hamburguer vive no MenuHeader. Ligar o jQuery direto no elemento
      // prendia o handler aquele <button> especifico: se o Vue recriasse o
      // botao, ele nascia morto. Escutando um evento, funciona em qualquer
      // re-render. O $off antes do $on evita listener duplicado se este
      // componente remontar — como isso e um toggle, dois listeners se
      // anulariam e o botao pararia de responder.
      this.$root.$off('mobile-nav-toggle', this.toggleMobileSidebar)
      this.$root.$on('mobile-nav-toggle', this.toggleMobileSidebar)
      $('html').on('click', function (s) {
        if ($(window).width() < 992) {
          if (!sidebar.hasClass('hide-sidebar') && sidebar.has(s.target).length === 0) {
            sidebar.addClass('hide-sidebar')
          }
        }
      })
      $('#sidebarClose').on('click', function () {
        sidebar.addClass('hide-sidebar')
      })
      $('[data-toggle="tooltip"]').tooltip()
      // o destaque do item ativo nao pode depender de nenhuma chamada de API:
      // num F5 ou link direto o menu precisa acertar de cara qual e a rota
      this.setActiveMenu()
      this.loadAccountPlan()
      this.loadOpenCharges()
      this.loadGoogleDataStudioRollout()
      this.loadIA4comRollout()
    })
    EventBus.$on('reload-charge-history', () => {
      this.loadOpenCharges()
    })
  },
  beforeDestroy () {
    this.$root.$off('mobile-nav-toggle', this.toggleMobileSidebar)
  },
  methods: {
    onLogoutClick () {
      if (this.isImpersonating === true) {
        this.$emit('request-logout')
        return
      }
      this.$store.dispatch('auth/signOut')
      localStorage.removeItem('financialData')
    },
    openTutorialGoogleDataStudio () {
      this.$emit('open-tutorial-google-datastudio')
    },
    toggleMobileSidebar () {
      $('.app-sidebar').toggleClass('hide-sidebar')
    },
    readCollapsedState () {
      try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'
      } catch (error) {
        return false
      }
    },
    persistCollapsedState (isCollapsed) {
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(isCollapsed))
      } catch (error) {
        console.error(error)
      }
    },
    handleSidebarHover (isHovered) {
      if (isHovered) {
        if (document.querySelector('.wrapper').classList.contains('nav-collapsed')) {
          document.querySelector('.wrapper').classList.remove('menu-collapsed')
          this.$root.$emit('sidebar-hover', true)
        }
      } else {
        if (document.querySelector('.wrapper').classList.contains('nav-collapsed')) {
          document.querySelector('.wrapper').classList.add('menu-collapsed')
          this.$root.$emit('sidebar-hover', false)
        }
      }
    },
    loadAccountPlan () {
      loopback
        .get('/accounts')
        .then(account => {
          this.isUnlimitedPlan = account.isUnlimited
          this.$nextTick(() => {
            this.setActiveMenu()
          })
          if (this.isAdmin) this.loadCampaignBadge()
        })
        .catch(error => {
          console.error(error)
        })
    },
    // Selo "BLACK" no item de planos: aparece junto com o banner da Black November, ou
    // seja, quando o catálogo da tela para onde o item leva tem a campanha, e até 29/11.
    // "Conhecer Planos" mostra a tabela da conta; "Planos e Assinatura", o catálogo de
    // contratação. Falha na chamada só deixa o selo de fora.
    loadCampaignBadge () {
      const purpose = this.isUnlimitedPlan ? undefined : 'contract'
      return loadAndMapOffers({ purpose }).then(list => {
        this.hasCampaignOffer = isCampaignBannerActive(list, Date.now())
      })
    },
    loadOpenCharges () {
      if (!this.isAdmin) return
      loopback
        .get('/charges', {
          params: {
            page: 1,
            filter: {
              where: { status: { inq: ['PENDING', 'OVERDUE'] } },
              order: 'createdAt DESC'
            }
          }
        })
        .then(charges => {
          if (!charges) return
          this.hasOverdueCharge = charges.data.some(charge => charge.status === 'OVERDUE')
          this.hasPendingCharge = charges.data.some(charge => charge.status === 'PENDING')
        })
        .catch(error => {
          console.error(error)
        })
    },
    loadGoogleDataStudioRollout () {
      loopback
        .get('/rollout?featureFlag=google-data-studio')
        .then(rollout => {
          this.isGoogleDataStudioAllowed = rollout === 'ALLOWED'
        })
        .catch(error => {
          this.isGoogleDataStudioAllowed = false
          console.error(error)
        })
    },
    // O IA4COM ainda e restrito: quem ve o item e so quem esta na tabela de
    // rollout do pbxapi. Esconder o item nao basta — a rota /assistant repete a
    // checagem em IA4COM/Index.vue, senao o link direto entraria do mesmo jeito.
    loadIA4comRollout () {
      isFeatureAllowed(IA4COM_FEATURE_FLAG)
        .then(isAllowed => {
          this.isIA4comAllowed = isAllowed
          // o item nasce escondido e so aparece depois da resposta; sem isto o
          // realce do item ativo ficaria calculado sobre uma lista que mudou
          this.$nextTick(() => {
            this.setActiveMenu()
          })
        })
    },
    onChargeChipClick () {
      if (this.$route.name !== 'chargeHistory') {
        this.$router.push({ name: 'chargeHistory' })
      }
    },
    setActiveMenu () {
      if (this.$route.matched[0]) {
        $(`#main-menu-navigation .active:not(.${this.$route.matched[0].name})`).removeClass('active')
        $(`.${this.$route.matched[0].name}`).addClass('active')
        if ($(`.${this.$route.matched[0].name}`).parent('.nav-item').hasClass('has-sub')) {
          // so "open": marcar o pai como ativo pintava o grupo inteiro de azul,
          // como se o usuario estivesse em todas as paginas do Suporte de uma vez.
          // quem acende e a linha em que voce esta, dentro do submenu
          $(`.${this.$route.matched[0].name}`).parent('.nav-item').addClass('open')
        } else {
          $('.nav-item.has-sub').removeClass('open')
        }
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    },
    isImpersonating () {
      const impersonation = this.$store.state.auth.impersonation
      return impersonation !== null && impersonation.active === true
    },
    isFounder () {
      const user = this.$store.state.auth.user
      const org = this.$store.state.auth.organization
      return !!(this.isAdmin && user && user.email && org && user.email === org.email)
    },
    showChargeChip () {
      return this.isAdmin && (this.hasOverdueCharge || this.hasPendingCharge)
    },
    chargeChipState () {
      return this.hasOverdueCharge ? 'overdue' : 'pending'
    },
    chargeChipText () {
      return this.hasOverdueCharge ? 'Cobrança vencida' : 'Cobrança em aberto'
    },
    collapseToggleLabel () {
      return this.isCollapsed ? 'Expandir menu' : 'Recolher menu'
    }
  },
  watch: {
    '$route' () {
      this.setActiveMenu()
    },
    '$store.state.auth.user': function () {
      this.loadOpenCharges()
    }
  }
}
</script>

<style lang="scss" scoped>
.header-brand-img {
  width: 26px;
  height: 26px;
}
// Alca de recolher, ancorada na borda direita do menu. O .app-sidebar e fixed,
// entao o absolute se posiciona contra ele: a alca acompanha a divisa sozinha
// quando o menu vai de 240px para 60px, sem precisar de regra por estado.
// O topo (46px) cai na costura entre o cabecalho e o primeiro item, para nao
// roubar area de clique de nenhuma linha do menu.
.sidebar-handle {
  position: absolute;
  top: 46px;
  right: -12px;
  z-index: 1041;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  background-color: #fff;
  color: #4a5568;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  transition: color 0.2s ease, box-shadow 0.2s ease;

  &:hover,
  &:focus {
    color: #0b77eb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
  }
}
// No mobile o menu abre e fecha pelo hamburguer; recolher nao faz sentido.
@media (max-width: 991px) {
  .sidebar-handle {
    display: none;
  }
}
.toggle-icon {
  line-height: 1;
}
// o iconkit nao tem glifo de marca nem de IA (o mais perto seria ik-cpu, que le
// como hardware): o SVG entra dentro do <i> para herdar tamanho, espacamento e
// cor de qualquer estado do menu (ativo, hover, colapsado)
.icon-whatsapp svg,
.icon-ia svg {
  width: 20px;
  height: 20px;
  display: block;
}
// A faisca e a UNICA coisa do menu que nao herda a cor do estado do item, e isso
// e de proposito: o ciano #36bbef e a cor da marca do IA4COM (a mesma do favicon
// e da faisca dentro do app) e passa a significar "aqui tem IA". Fixa, ela
// identifica o item de relance numa lista em que todo o resto e monocromatico —
// e continua sendo a mesma cor do lado de dentro do iframe, o que costura as
// duas metades da tela.
.icon-ia {
  color: #36bbef;
}
.header-brand-name-img {
  width: 150px;
  height: 26px;
}
/* mesma linguagem do item ativo do menu principal (barra azul + fundo sutil + negrito),
   mas na propria linha do submenu: o destaque marca a pagina em que voce esta, nao o grupo.
   o azul #0b77eb ficava escuro demais sobre o fundo do submenu (#4a5872) */
.submenu-content.active a.menu-item {
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: inset 3px 0 0 #0b77eb;
  font-weight: 600;
}
.submenu-content.active a.menu-item span {
  color: #4d9bf5;
}
.menu-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.badge {
  position: static !important;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 8px;
  text-transform: uppercase;
  display: inline-block;
  &.new,
  &.beta {
    background-color: #007bff;
    color: #fff !important;
  }
  // Selo da Black November, como no Figma (2054:1649).
  &.black {
    padding: 4px 7px;
    border-radius: 4px;
    background-color: #ffd23f;
    color: #120d00 !important;
    font-weight: 800;
    line-height: 10px;
  }
}
.nav-collapsed.menu-collapsed .menu-label .badge {
  display: none;
}
// Separa a navegação de trabalho da área utilitária (suporte / sair).
// margin-top: auto ancora o divisor (e a área utilitária) no rodapé, em vez de
// flutuar no meio do vazio.
.nav-divider {
  height: 1px;
  margin: auto 16px 14px;
  background-color: rgba(255, 255, 255, 0.15);
}
// A cadeia vira flex-column para que a área utilitária possa ser empurrada
// para o fim. O .sidebar-content já tem altura fixa e overflow auto, então o
// menu continua rolando normalmente quando não couber na tela.
.sidebar-content {
  display: flex;
  flex-direction: column;
}
.nav-container,
.navigation-main {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
}
// Área utilitária: acessada com pouca frequência, fica ancorada no rodapé e
// visualmente rebaixada.
.nav-utility {
  margin-top: auto;
  padding-top: 8px;
  .nav-item > a {
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
}
// Quando o divisor precede a área utilitária, ele já faz a ancoragem no rodapé,
// então a área utilitária não repete o margin-top.
.nav-divider + .nav-utility {
  margin-top: 0;
}
.charge-alert-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 12px 8px 12px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  border-left: 4px solid transparent;
  transition: filter 0.15s ease-in-out;
  i {
    font-size: 16px;
    line-height: 1;
  }
  span {
    line-height: 1.2;
  }
  &:hover {
    text-decoration: none;
    filter: brightness(0.95);
  }
  &.pending {
    background-color: rgba(245, 166, 35, 0.12);
    border-left-color: #f5a623;
    color: #f5f0e6 !important;
    i { color: #f5a623 !important; }
    span { color: #f5f0e6 !important; }
  }
  &.overdue {
    background-color: rgba(224, 36, 36, 0.15);
    border-left-color: #e02424;
    color: #fdecec !important;
    i { color: #ff5b5b !important; }
    span { color: #fdecec !important; }
  }
}
.nav-collapsed.menu-collapsed .charge-alert-chip {
  span {
    display: none;
  }
  justify-content: center;
  margin-left: 8px;
  margin-right: 8px;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Container/MenuSidebar.vue